import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GSC_REQUEST_SUMMARY_QUERY_KEY } from '../../constants/queryKeys';
import { GET_GSC_REQUEST_SUMMARY_URL } from '../../constants/apiUrls';
import { GroupScType } from '../../models/SpecialConsideration';
import { FileProcessingState } from '../../models/File';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface RequestSummaryDetailResponse {
  explanation?: string;
  reasonCode?: string;
  specialConsiderationTypeCode?: string;
}

interface GetRequestSummaryResponse extends RequestSummaryDetailResponse {
  groupScType: GroupScType;
  lastUpdatedTime: string;
  applicationId: string;
  fileUuid?: string;
  fileStatus?: FileProcessingState;
  examLevel?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetRequestSummaryResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  refetchInterval?: number;
  enabled?: boolean;
}

export const useGetRequestSummary = ({
  uuid,
  onSuccess,
  onError,
  refetchInterval,
  enabled = true,
}: Input) => {
  const getRequestSummary = async () => {
    const res = await axiosClient.get<GetRequestSummaryResponse>(GET_GSC_REQUEST_SUMMARY_URL(uuid));
    return res.data;
  };
  return useCustomQuery([GET_GSC_REQUEST_SUMMARY_QUERY_KEY], getRequestSummary, {
    onSuccess,
    onError,
    refetchInterval,
    enabled,
  });
};
